import { Box, Tooltip, Typography } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const ActionsCell = ({ params, setSelectedBay, setOpenDeleteBay }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        height: "100%",
        minHeight: "52px",
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        sx={{
          backgroundColor: "#FAFAFA",
          borderRadius: "6px",
          border: "1px solid #E0E0E0",
          padding: "4px 8px",
          gap: 1,
        }}
      >
        <Tooltip title="Delete">
          <Box
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
              padding: "4px 8px",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#F0F0F0",
              },
            }}
            onClick={() => {
              setSelectedBay(params.row);
              setOpenDeleteBay(true);
            }}
          >
            <DeleteForeverIcon fontSize="small" color="error" />
            <Typography
              variant="body2"
              sx={(theme) => ({
                ml: 1,
                fontSize: "13px",
                fontWeight: 500,
                color: theme.palette.error.main,
              })}
            >
              Delete
            </Typography>
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default ActionsCell;
